export const SegmentsPaths = {
    new: "new",
    edit: ":segmentId",
} as const;
